import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconOutline = createAsyncIcon(() => import('./SolarIconOutline'));

export default AsyncSolarIconOutline;

AsyncSolarIconOutline.displayName = 'AsyncSolarIconOutline';
